import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'

import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { CreateRegisterAction } from '../../../redux/actions/user'
import * as types from '../../../redux/constantes/user'

import { VerifyValidationButton } from '../../../components/User/VerifyValidationButton'
import { ContainerContent, ContainerTemplate } from '../../../components/Containers'
import { MessageBoxError, MessageBoxSuccess } from '../../../components/MessageBox'
import { SelectCourse } from '../../../components/User/SelectCourse'
import { InputUser } from '../../../components/User/InputUser'
import { ButtonSend } from '../../../components/ButtonSend'
import { Header } from '../../../components/User/Header'
import { Title } from '../../../components/User/Title'
import { InputPhone } from '../../../components/User/InputPhone'
import { ModalConfirmation } from '../../../components/User/ModalConfirmation'
import { LGPD } from '../../../components/User/LGPD'
import { WrapperButtonsModal } from '../../../components/User/ModalConfirmation/style'

type ICourses = {
  courseName: string
}

export const TemplateRegister: React.FC = () => {
  const { loading, success, error } = useSelector((state: RootStateOrAny) => state.createUser)
  const dispatch = useDispatch()
  const history = useHistory()

  const [courses, setCourses] = useState<ICourses[]>([{ courseName: '' }])
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [name, setName] = useState('')
  const [cpf, setCpf] = useState('')

  const [isVerify, setIsVerify] = useState(false)
  const [validateCpf, setValidateCpf] = useState(true)
  const [validateName, setValidateName] = useState(true)
  const [validateEmail, setValidateEmail] = useState(true)
  const [validatePhone, setValidatePhone] = useState(true)
  const [validateCourses, setValidateCourses] = useState(true)
  const [disableAllInputs, setDisableAllInputs] = useState(false)

  const [preConfirmed, setPreConfirmed] = useState(false)

  const validateAcceptedTerms = () => {
    nameIsValid()
    cpfIsValid()
    emailIsValid()
    phoneIsValid()
    coursesIsValid()
    setIsVerify(true)
  }

  const nameIsValid = () => {
    if (name === '') {
      setValidateName(false)
    } else {
      setValidateName(true)
    }
  }

  const cpfIsValid = () => {
    const cpfRegex = /^\d{3}.\d{3}.\d{3}-\d{2}$/
    if (cpfRegex.test(cpf)) {
      setValidateCpf(true)
    } else {
      setValidateCpf(false)
    }
  }

  const emailIsValid = () => {
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    if (emailRegex.test(email)) {
      setValidateEmail(true)
    } else {
      setValidateEmail(false)
    }
  }

  const phoneIsValid = () => {
    // eslint-disable-next-line no-useless-escape
    const phoneRegex = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/
    if (phoneRegex.test(phone)) {
      setValidatePhone(true)
    } else {
      setValidatePhone(false)
    }
  }

  const coursesIsValid = () => {
    if (courses[0].courseName === '') {
      setValidateCourses(false)
    } else {
      setValidateCourses(true)
    }
  }

  const fullValidations = () => {
    if (validateName && validateCpf && validateEmail && validatePhone && validateCourses && isVerify) {
      return false
    } else {
      return true
    }
  }

  const onSubmit = () => {
    setPreConfirmed(false)
    const phoneFormate = `+55 ${phone}`
    dispatch(CreateRegisterAction(name, cpf, email, phoneFormate, courses))
  }

  useEffect(() => {
    if (success) {
      setDisableAllInputs(true)
      setIsVerify(false)
      setTimeout(() => {
        dispatch({ type: types.CREATE_REGISTER_RESET })
        history.push('/validar-codigo')
      }, 5000)
    }
    if (error) {
      setTimeout(() => {
        dispatch({ type: types.CREATE_REGISTER_RESET })
      }, 5000)
    }
  }, [success, error])

  return (
    <ContainerTemplate>
      <Header />
      <ContainerContent>
        <Title text="Insira aqui os seus dados para o pré-cadastro" />
        <InputUser
          label={`Nome Completo ${!validateName ? '(Campo obrigatório esta em branco)' : ''}`}
          onBlur={nameIsValid}
          onChange={e => setName(e.target.value)}
          placeholder="exemplo: Augusto Ferreira da Silva"
          value={name}
          isValidate={validateName}
          disabled={disableAllInputs}
        />
        <InputUser
          label={`CPF ${!validateCpf ? '(Campo obrigatório esta em branco ou incorreto)' : ''}`}
          onBlur={cpfIsValid}
          onChange={e => setCpf(e.target.value)}
          placeholder="exemplo: 123.456.789-00"
          value={cpf}
          isValidate={validateCpf}
          disabled={disableAllInputs}
        />
        <InputUser
          label={`E-mail ${!validateEmail ? '(Campo obrigatório esta em branco ou incorreto)' : ''}`}
          onBlur={emailIsValid}
          onChange={e => setEmail(e.target.value)}
          placeholder="exemplo: email@gmail.com"
          value={email}
          isValidate={validateEmail}
          disabled={disableAllInputs}
        />
        <InputPhone
          label={`Celular (DDD + número) ${!validatePhone ? '(Campo obrigatório esta em branco ou incorreto)' : ''}`}
          onBlur={phoneIsValid}
          onChange={e => setPhone(e.target.value)}
          placeholder="exemplo: (11) 98888-8888"
          value={phone}
          isValidate={validatePhone}
          disabled={disableAllInputs}
        />
        <SelectCourse setCourses={setCourses} courses={courses} setValidateCourses={setValidateCourses} />
        <LGPD validateAcceptedTerms={validateAcceptedTerms} isVerify={isVerify} setIsVerify={setIsVerify} />
        {!loading ? (
          <WrapperButtonsModal>
            <VerifyValidationButton />
            <ButtonSend
              nameButton="Enviar pré-cadastro"
              disabled={fullValidations()}
              onClick={() => setPreConfirmed(true)}
            />
          </WrapperButtonsModal>
        ) : (
          <ButtonSend nameButton="Aguarde..." disabled={true} />
        )}
        {preConfirmed && (
          <ModalConfirmation
            onSubmit={onSubmit}
            setPreConfirmed={setPreConfirmed}
            courses={courses}
            email={email}
            phone={phone}
            name={name}
            cpf={cpf}
          />
        )}

        {success && <MessageBoxSuccess>{success}</MessageBoxSuccess>}
        {error && <MessageBoxError>{error}</MessageBoxError>}
        {!validateCourses && <MessageBoxError>Você ainda não escolheu um dos cursos!</MessageBoxError>}
      </ContainerContent>
    </ContainerTemplate>
  )
}
